module.exports = __webpack_public_path__ + "img/xhs.31867076.jpg";